import { Trans } from '@lingui/react/macro';

import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { BaseMessage } from './BaseMessage';

export const ConfirmExchangeStockAvailabilityTaskMessage = () => {
  const { article, iam } = useArticleContext();

  return (
    <BaseMessage
      title={
        <Trans id="article.task.confirm-exchange-stock-availability.title">
          Verify and confirm stock
        </Trans>
      }
      message={
        iam.hasUserScopeOnArticle('stockLocation') ? (
          <Trans id="article.task.confirm-exchange-stock-availability.message">
            Please confirm whether this item can be reserved for the exchange.
          </Trans>
        ) : (
          <Trans id="article.task.confirm-exchange-stock-availability.on-behalf.message">
            Please contact the stock location to confirm whether this item can be reserved for the
            exchange.
          </Trans>
        )
      }
      article={article}
    />
  );
};
